<template>
  <div class="app-header-logo">
    <div class="inner-width">
      <router-link to="/" class="app-header-logo__link" exact>
        <img src="../assets/images/app_logo.jpg" class="app-header-logo__image">
      </router-link>
    </div>
  </div>
</template>


<script>
export default {
  name: 'AppHeaderLogo',
}
</script>
